<script>
import http from "@state/http";
import Profile from "./profile.vue";
import substr_replace from "@views/asset/js/substr_replace";

export default {
  components: {Profile},
  data() {
    return {
      ses_id: '',
      ses_info: {},
      qry: "",
      flag: false,
      results: [],
    }
  },
  mounted() {
    this.ses_id = this.$route.params.ses_id;
    this.getSesInfo();
  },
  methods: {
    search() {
      this.results = [];
      if (this.qry.length === 0 || this.qry === '') {
        return [];
      }
      http
          .post("api/ses/auto-search", {
            qry: this.qry
          })
          .then(response => {
            this.flag = true;
            this.results = response.data.results;
          })
          .catch();
    },
    getSesInfo(){
      let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/personal/" + ses_id).then(response => {
        if (!response.error) {
          this.flag = true;
          this.ses_info = response.data.ses_info;
        }
      });
    },
  },
}
</script>

<template>
  <aside class="p_sidebar">
    <nav>
      <ul class="p_active">
        <li v-if="Object.keys(ses_info).length !== 0" >
          <span class="list-group-item border-0" style="color: #10948E">{{ ses_info != null ? ses_info.name : '' }} ({{ ( ses_info != null || ses_info.ep_id != null) ? ses_info.ep_id.ep_id : '' }})</span>
        </li>
        <li>
          <button v-b-toggle.profile-sidebar-right  class="list-group-item border-0" style="color: #000">
            <i class="fe-user"></i>
            Profile
          </button>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpPersonalInformation', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-user"></i>
            Personal Information
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpHousehold', params: {ses_id: ses_id}}" class="list-group-item border-0"  active-class="active">
            <i class="fe-home"></i>
            Household
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpLand', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-menu"></i>
            Land
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpStructure', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-layers"></i>
            Structure
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpStructureRent', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-layers"></i>
            Structure Rent
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpTree', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-grid"></i>
            Tree
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpBusiness', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-briefcase"></i>
            Business
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpBusinessEmployee', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-users"></i>
            Business Employee
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpVoucher', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-dollar-sign"></i>
            Voucher
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpBank', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-briefcase"></i>
            Bank
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpDocument', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-file-text"></i>
            Document
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpPresentAddress', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-book"></i>
            Present Address
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpEpEcVoucher', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-dollar-sign"></i>
            Ep/Ec/Voucher
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpFileTracking', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-file-text"></i>
            File Tracking
          </router-link>
        </li>
        <li>
          <router-link tag="a" :to="{name: 'EpSesWorker', params: {ses_id: ses_id}}" class="list-group-item border-0" active-class="active">
            <i class="fe-briefcase"></i>
            Ses Worker
          </router-link>
        </li>
      </ul>
      <profile></profile>
    </nav>
  </aside>
</template>
<style>

.list-group-item.active {
  z-index: 2;
  color: #6658dd;
  background-color: #fff !important;
  border-color: #6658dd !important;
}

.p_active .list-group-item .active {
  color: #6658dd !important;
  background-color: #fff !important;
}
.p_active li {
  border-bottom: 1px solid #10948e30;
}

.p_active li a {
  color: #000;
}

.p_sidebar, .p_main {
  transition: all .3s ease-out;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  top: 64px;
  bottom: 0;
}

.p_sidebar {
  width: 260px;
  background-color: #fff;
  left: 0;
  margin-bottom: 20px;
}

.p_main {
  position: absolute;
  left: 260px;
  right: 0;
  /*padding: 20px;*/
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}
</style>